export function plSnapshotFromKpis(k: any, yearIndex = 2) {
  try {
    // Базовые данные
    const baseADR = k?.roomRevenue?.totals?.avgADR || 20;
    const baseOccPct = k?.roomRevenue?.totals?.avgOccPct || 75.38;
    const rooms = k?.rooms?.total || 22;

    // Ramp настройки
    const rampSettings = k?.rampSettings;
    const revenueRamp = rampSettings?.revenueRamp || [0.7, 0.8, 0.9, 1.0];
    const toplineGrowthPct = rampSettings?.toplineGrowthPct || 2;
    const growthRate = toplineGrowthPct / 100;

    // Year number (yearIndex = 0 → Year 1, yearIndex = 2 → Year 3)
    const yearNum = yearIndex + 1;

    // Рассчитываем ADR для указанного года
    const revRampMul = yearNum <= 4 ? revenueRamp[yearNum - 1] : 1.0;
    const growthIndex = Math.pow(1 + growthRate, yearNum);
    const adr = baseADR * revRampMul * growthIndex;

    // Occupancy для указанного года
    const occFraction = (baseOccPct / 100) * revRampMul;

    // RevPAR = ADR × Occupancy fraction
    const revpar = adr * occFraction;

    return {
      yearIndex,
      adr,
      revpar,
    };
  } catch (error) {
    console.error("Error in plSnapshotFromKpis:", error);
    return {
      yearIndex,
      adr: 0,
      revpar: 0,
    };
  }
}
